var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('app-bar'),_c('v-main',[_c('v-row',[_c('v-col',{attrs:{"cols":"2"}},[_c('sidebar')],1),_c('v-col',[_c('router-view')],1)],1),_c('snackbar-widget')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }